import React, { useContext, useEffect } from 'react';

import { AppAside, AppFooter, AppHeader } from '@coreui/react';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import { useParams } from 'react-router';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { Container } from 'reactstrap';

import { launchDashboard } from '../../_nav';
import MatomoContext from '../../MatomoContext';
import routes from '../../routes';
import { prefix as academyPrefix } from '../../routes/academy';
import appRouter from '../../services/AppRouter/AppRouter';
import authService from '../../services/Auth';
import AcademyContextProvider from '../../views/Academy/contexts/Academy.context';
import DefaultAside from './DefaultAside';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';
import SideBar from './SideBar';

function PageTracking({ title, children }) {
  const matomoContext = useContext(MatomoContext);
  const { trackPageView, pushInstruction } = useMatomo();
  const params = useParams();

  useEffect(() => {
    if (matomoContext && matomoContext.userId !== 'unauthenticated') {
      trackPageView({
        documentTitle: title(params),
        href: window.location.href,
      });
    }
  }, [params, title, pushInstruction, trackPageView, matomoContext]);
  return children;
}

function buildRoutes(routes) {
  return routes.map((route, idx) => {
    if (route.redirectTo)
      return <Route key={idx} path={route.path} render={() => <Redirect to={route.redirectTo} />} />;

    if (!route.component) return null;

    const RouteComponent = route.wrapper || Route;

    return (
      <RouteComponent
        {...route.wrapperArgs}
        key={idx}
        path={route.path}
        exact={route.exact}
        name={route.name}
        render={props => (
          <PageTracking title={params => (route.customTitle ? route.customTitle(params) : 'DigitRE Intranet / PRM')}>
            <route.component {...props} />
          </PageTracking>
        )}
      />
    );
  });
}

const DefaultLayout = props => {
  const location = useLocation();
  const currentPathsRoute = appRouter.getHistory().location.pathname.match(/^\/([a-z-]*)\/([a-z-]*)\/?([a-z-]*)?/i);

  return (
    <>
      {!authService.isAuthenticated() ? (
        <Redirect to='/login' />
      ) : currentPathsRoute?.input?.includes('/leader') ? (
        <div className='iframe-body'>
          <Switch>{authService.isAuthenticated() && buildRoutes(routes)}</Switch>
        </div>
      ) : (
        <div className={`app${currentPathsRoute !== null ? ' route-' + currentPathsRoute[1] : ''}`}>
          <div className='app-body'>
            <SideBar location={location} />
            <main className='main'>
              <AppHeader fixed>
                <DefaultHeader {...props} />
              </AppHeader>

              <div className={'empty-breadcrumb'} />

              <Container fluid className={'padding-mobile-header pt-3'}>
                {location.pathname.startsWith(academyPrefix) ? (
                  <AcademyContextProvider>
                    <Switch>
                      {authService.isAuthenticated() && buildRoutes(routes)}
                      {authService.isAuthenticated() && <Redirect exact from='/' to={launchDashboard()} />}
                      <Redirect from='*' to={authService.getUserHome()} />
                    </Switch>
                  </AcademyContextProvider>
                ) : (
                  <Switch>
                    {authService.isAuthenticated() && buildRoutes(routes)}
                    {authService.isAuthenticated() && <Redirect exact from='/' to={launchDashboard()} />}
                    <Redirect from='*' to={authService.getUserHome()} />
                  </Switch>
                )}
              </Container>
            </main>
            <AppAside fixed hidden>
              <DefaultAside />
            </AppAside>
          </div>
          <AppFooter>
            <DefaultFooter />
          </AppFooter>
        </div>
      )}
    </>
  );
};

export default DefaultLayout;
